// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._35T8y{width:430px;width:43rem}._1KRkK{display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;background-color:#fff;border-radius:50%;height:40px;height:4rem;justify-content:center;overflow:hidden;width:40px;width:4rem}._1w6lr{max-height:100%;width:auto}._1JbF_{color:#fff;display:block;font-size:15px;font-size:1.5rem;font-weight:700}._1g-rh{fill:#6f7ea2;height:20px;height:2rem;width:4px;width:.4rem}._3p4ld{color:#30a8ff;display:block;font-size:16px;font-size:1.6rem;font-weight:400;height:calc(1.715em + 1.4rem + 2px);line-height:1.715em;margin-top:calc(1.715rem - 2px);padding:0 1.5rem}._3p4ld .btn__labelWrapper{padding:0}", ""]);
// Exports
exports.locals = {
	"form": "_35T8y",
	"avatar": "_1KRkK",
	"avatar__img": "_1w6lr",
	"avatar__initials": "_1JbF_",
	"menu__icon": "_1g-rh",
	"toggleFormBtn": "_3p4ld"
};
module.exports = exports;
